import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LinkedMaps from "../LinkedMaps/LinkedMaps";
import DataGrid from "../DataGrid/DataGrid";
import SideBar from "../SideBar/SideBar";
import "../Map.css";
import "./Mobile.css";

const Mobile = () => {
    const streetViewOn = useSelector((state) => state.toolSelect.streetView);
    const dataGridOn = useSelector((state) => state.toolSelect.dataGrid);

    const [selected, setSelected] = useState();

    const activateSideBar = (e) => {
        console.log(e);
        setSelected("sidebar");
    };

    const activateDataGrid = () => {
        setSelected("datagrid");
    };

    const activateStreetView = () => {
        setSelected("streetview");
    };

    useEffect(() => {
        if (streetViewOn) {
            setSelected("streetview");
        } else {
            setSelected("sidebar");
        }
    }, [streetViewOn]);

    useEffect(() => {
        if (dataGridOn) {
            setSelected("datagrid");
        } else {
            setSelected("sidebar");
        }
    }, [dataGridOn]);

    return (
        <div className="split-content">
            <div className="split-pane-header">
                <div
                    className={`mobile-tab ${selected === "sidebar" ? "selected" : ""}`}
                    onClick={activateSideBar}>
                    Menu
                </div>
                {dataGridOn && (
                    <div
                        className={`mobile-tab ${
                            selected === "datagrid" ? "selected" : ""
                        }`}
                        onClick={activateDataGrid}>
                        Table View
                    </div>
                )}
                {streetViewOn && (
                    <div
                        className={`mobile-tab ${
                            selected === "streetview" ? "selected" : ""
                        }`}
                        onClick={activateStreetView}>
                        Street View
                    </div>
                )}
            </div>
            <div className="split-pane-body">
                <div className={`pane-child ${selected !== "sidebar" ? "hidden" : ""}`}>
                    <SideBar />
                </div>

                {streetViewOn && (
                    <div
                        className={`pane-child ${
                            selected !== "streetview" ? "hidden" : ""
                        }`}>
                        <LinkedMaps />
                    </div>
                )}
                {dataGridOn && (
                    <div
                        className={`pane-child ${
                            selected !== "datagrid" ? "hidden" : ""
                        }`}>
                        {" "}
                        <DataGrid />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Mobile;
